module.exports = __webpack_public_path__ + "band_2.4be65c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_2.png
// module id = G+rE
// module chunks = 0